// @flow
import React from 'react';
import { translate, type TFunction } from 'react-i18next';
import { Text, Button } from '@locus-taxy/neo-ui';
import { SortActionTypes } from 'common/enums/PlanFilterEnum';

type Props = {
    selected: boolean,
    t: TFunction,
    text?: string,
    'data-test-id'?: string,
    type: SortActionTypes,
    onClick: Event => void,
    width?: number,
    disabled?: boolean,
    hideIcon?: boolean
};

const selectedColorStyle = {
    color: 'white',
    backgroundColor: 'blue.500',
    borderColor: 'grey.200'
};

const deselectedColorStyle = {
    color: 'blue.500',
    backgroundColor: 'transparent',
    borderColor: 'grey.200'
};

const isSelectedToButtonStyleMap = {
    true: {
        ...selectedColorStyle,
        borderRadius: 20,
        '&:hover': {
            ...selectedColorStyle
        },
        '&:focus': {
            ...selectedColorStyle,
            outline: 'none',
            boxShadow: 'none'
        }
    },
    false: {
        ...deselectedColorStyle,
        borderRadius: 20,
        '&:hover': {
            ...deselectedColorStyle
        },
        '&:focus': {
            ...deselectedColorStyle,
            outline: 'none',
            boxShadow: 'none'
        }
    }
};

const SortButton = ({
    selected,
    onClick,
    t,
    text,
    type,
    'data-test-id': dataTestId,
    width = 132,
    disabled = false,
    hideIcon = false
}: Props) => {
    const sx = isSelectedToButtonStyleMap[selected];
    const ascending = type === SortActionTypes.ASC;

    return (
        <Button
            width={width}
            data-test-id={dataTestId}
            icon={
                !hideIcon
                    ? ascending
                        ? 'sort_ascending_text'
                        : 'sort_descending_text'
                    : null
            }
            onClick={onClick}
            appearance="outline"
            sx={sx}
            disabled={disabled}
        >
            <Text textTransform="none" fontWeight="bold">
                {text || (ascending ? t('ascending') : t('descending'))}
            </Text>
        </Button>
    );
};

export default translate('planner')(SortButton);
